var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "add-work-phone" }, [
    _c("div", { staticClass: "content" }, [
      _vm._m(0),
      _c("div", { staticClass: "text" }, [_vm._v("基本信息")]),
      _c(
        "div",
        { staticClass: "forms" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: {
                inline: true,
                model: _vm.form,
                rules: _vm.rules,
                size: "small",
                "label-width": "96px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "工作手机号", prop: "phone" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入",
                      maxlength: "11",
                      clearable: "",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phone", $$v)
                      },
                      expression: "form.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "运营商", prop: "phoneOperator" } },
                [
                  _vm.dictionaries.phone_operator
                    ? _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.phoneOperator,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "phoneOperator", $$v)
                            },
                            expression: "form.phoneOperator",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.phone_operator,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "t-label", attrs: { label: "实名人" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "204px" },
                    attrs: {
                      placeholder: "请输入",
                      clearable: "",
                      maxlength: "30",
                      type: "textarea",
                      rows: "3",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "t-label",
                  attrs: { label: "手机号备注", prop: "remarks" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "204px" },
                    attrs: {
                      placeholder: "请输入",
                      clearable: "",
                      maxlength: "64",
                      type: "textarea",
                      rows: "3",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "footer",
          class: [_vm.isCollapsed ? "footer-collapsed" : ""],
        },
        [
          _c(
            "el-button",
            { attrs: { type: "info", plain: "" }, on: { click: _vm.back } },
            [_vm._v("返回")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary", plain: "" }, on: { click: _vm.reset } },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.btnSave },
              on: { click: _vm.save },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "data-title" }, [
      _c("div", { staticClass: "title-name" }, [_vm._v("新增工作手机号")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }